import { useContext } from 'react';
import { createHMRProofContext } from '../utils/createHMRProofContext';

export type QrOnScreen = {
  /** The phone drawer shows the QR code (the fallback for another device). */
  shown: boolean;
  setShown: (shown: boolean) => void;
};

/**
 * Kept by the phone drawer's shell, which stays mounted while the session
 * restarts: an expired request fades the QR code in place only when it was on
 * screen, and "Refresh QR" comes back to it.
 */
export const QrOnScreenContext = createHMRProofContext<QrOnScreen>(
  'QrOnScreenContext',
  { shown: false, setShown: () => undefined },
);

export function useQrOnScreen(): QrOnScreen {
  return useContext(QrOnScreenContext);
}
